/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCatalogConfig } from '../../models/api-response-catalog-config';

export interface DeleteCatalogField$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  fieldId: string;
}

export function deleteCatalogField(http: HttpClient, rootUrl: string, params: DeleteCatalogField$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCatalogConfig>> {
  const rb = new RequestBuilder(rootUrl, deleteCatalogField.PATH, 'delete');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('fieldId', params.fieldId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCatalogConfig>;
    })
  );
}

deleteCatalogField.PATH = '/v1/api/ui/company/catalog-config/field/{fieldId}';
